import { render, staticRenderFns } from "./ButtonOrder.vue?vue&type=template&id=f651d9be&scoped=true&"
import script from "./ButtonOrder.vue?vue&type=script&lang=js&"
export * from "./ButtonOrder.vue?vue&type=script&lang=js&"
import style0 from "./ButtonOrder.vue?vue&type=style&index=0&id=f651d9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f651d9be",
  null
  
)

export default component.exports